import React from "react";

import { Link } from "react-router-dom";
import { useDebounce } from "usehooks-ts";

import { useNavbarExpanded } from "@/atoms/navbar-atom";
import { usePageTitle } from "@/atoms/page-title-atom";
import northbeamHeaderLogo from "@assets/northbeam-header-logo.svg";
import northbeamHeaderText from "@assets/northbeam-header-text.svg";

import { NavbarDivider } from "./nav-bar-divider";
import { NavbarTitle } from "./nav-bar-title";

export const TopBarLogoAndDynamicTitle = () => {
  const [expanded] = useNavbarExpanded();
  const [pageTitle] = usePageTitle();

  const debouncedExpanded = useDebounce(expanded, 250);

  return (
    <div className="flex items-center">
      <div className="flex-center cursor-pointer w-14 bg-white">
        <Link to="overview">
          <img
            src={northbeamHeaderLogo}
            alt="Northbeam logo"
            style={{ imageRendering: "crisp-edges" }}
          />
        </Link>
      </div>
      {debouncedExpanded || !pageTitle ? (
        <img
          className="animate__animated animate__fadeIn animate__faster"
          src={northbeamHeaderText}
          alt="Northbeam text"
        />
      ) : (
        <div className="animate__animated animate__fadeIn animate__fast flex items-center">
          <NavbarDivider className="mr-3" />
          <NavbarTitle />
        </div>
      )}
    </div>
  );
};
